import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SystemService } from '../../../camtl.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'construction-integration',
  templateUrl: './construction-integration.component.html',
  // styleUrls: ['./construction-integration.component.scss']
})
export class ConstructionIntegrationComponent implements OnInit, OnDestroy {


  constructor(private service: SystemService,
    private systemSelectService: SystemSelectService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
  ) { }

  system: any;
  showFloorSpace: boolean = false;
  disableSubmission: boolean = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        this.toggleFloorSpace();
        if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
          this.disableSubmission = true;
        }
        else {
          this.disableSubmission = false;
        }
      });

    this.systemSelectService.get();
    this.toggleFloorSpace();
  }

  ngOnChanges() {
    this.toggleFloorSpace();
    this.systemSelectService.get();
  }

  onSystemChange(newValue) {
    this.toggleFloorSpace();
  }

  onCheckboxClick(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var id = target.attributes.id.nodeValue;

    this.setCheckboxes(id);
  }

  toggleFloorSpace() {
    if (this.system && (this.system.SystemSurroundSetup || this.system.FullIntegration || this.system.HomeLine)) {
      this.showFloorSpace = true;
    }
    else {
      this.showFloorSpace = false;
      if (this.system) {
        this.system.Length = 0;
        this.system.Width = 0;
        this.system.Height = 0;
      }
    }
  }

  disableSubmit() {
    return this.disableSubmission;
  }

  setCheckboxes(id) {
    var system = this.system;

    switch (id) {
      case "FullIntegration":
        this.system.ToolConstruction = false;
        this.system.RobotTestCell = false;
        this.system.SystemSurroundSetup = false;
        this.system.HomeLine = false;
        break;
      case "HomeLine":
        this.system.ToolConstruction = false;
        this.system.RobotTestCell = false;
        this.system.SystemSurroundSetup = false;
        this.system.FullIntegration = false;
        break;
      default:
        this.system.FullIntegration = false;
        this.system.HomeLine = false;
        break;
    }
  }

  updateSystem(e) {
    var self = this;
    this.service.save(this.system, false)
      .then(function () {
        self.cgpSnackbarService.showSnackbar({
          message: 'System has been updated',
          duration: 2000
        });
        return null;
      }).catch(function (response) {
        this.service.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      });

  }

}
